import { takeEvery, all, select, put } from 'redux-saga/effects';
import { GET_MY } from '../../containers/App/constants';
import { selectWorkflowsFilter } from './selectors';
import { FILTER_DEFAULT_LIMIT, REQUEST_WORKFLOWS, REQUEST_WORKFLOWS_FILTER } from "./constants";

function* requestWorkflowsFilter() {
  let filter = yield select(selectWorkflowsFilter());

  let offset = filter.offset || 0;
  let limit = filter.limit || FILTER_DEFAULT_LIMIT;
  let searchString = filter.searchString || null;
  let companyId = filter.companyId || null;

  let path = `workflows?offset=${offset}&limit=${limit}`;
  if (searchString) path += `&searchString=${searchString}`;
  if (companyId) path += `&companyId=${companyId}`;

  yield put({
    type: GET_MY,
    id: REQUEST_WORKFLOWS,
    work: REQUEST_WORKFLOWS,
    gate: REQUEST_WORKFLOWS,
    path,
  });
}

export function* workflowsSaga() {
  yield all([takeEvery(REQUEST_WORKFLOWS_FILTER, requestWorkflowsFilter)]);
}
